import { reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import * as _ from 'lodash'

export const TagList = (props, context) => {
  const store = context.root.$store
  const { tag } = store.state

  const data = reactive({
    lists: computed(() => tag.lists[state.visibleTarget]),
    count: computed(() => tag.count[state.visibleTarget]),
    // SP用
    listsAll: computed(() => tag.lists),
    countAll: computed(() => tag.count),
    // 全読み込み済みフラグ
    complete: computed(() => tag.complete)
  })

  const state = reactive({
    visibleToast: false,
    visibleTagEdit: false,
    visibleTagDeleteConfirm: false,
    visibleTagSharedList: false,
    visibleTarget: computed(() => tag.currentType),
    visibleTargetName: computed(() => tag.currentTypeName),
    visibleTargetNumber: tag.currentTypeNumber
  })


  const action = {
    load: () => {
      store.dispatch('tag/getLists')
    },
    sharedItem: (id, name) => {
      store.dispatch('tag/setEditId', id)
      if (name) {
        store.dispatch('tag/setEditName', name)
      }
      store.dispatch('tag/getSharedList')
      state.visibleTagSharedList = true
    },
    editItem: (id) => {
      store.dispatch('tag/setEditId', id)
      state.visibleTagEdit = true
    },
    deleteItem: (id) => {
      store.dispatch('tag/setEditId', id)
      state.visibleTagDeleteConfirm = true
    },
    changeType: (type) => {
      store.dispatch('tag/changeType', type)
    },
    onCarouselChange: (number) => {
      state.visibleTargetNumber = number
  
      const type = (() => {
        switch (number) {
          case 0: return 'note'
          case 1: return 'bookmark'
          case 2: return 'search'
          default: return false
        }
      })()
      store.dispatch('tag/changeType', type)
    }
  }

  // 初回リスト読み込み
  action.load()

  return {
    state,
    data,
    action
  }
}
